const UPLAY_ACTIVATE_GAME_REQUEST = 'UPLAY_ACTIVATE_GAME_REQUEST'
const UPLAY_ACTIVATE_GAME_SUCCESS = 'UPLAY_ACTIVATE_GAME_SUCCESS'
const UPLAY_ACTIVATE_GAME_FAILURE = 'UPLAY_ACTIVATE_GAME_FAILURE'
const UPLAY_AUTHENTICATE_SUCCESS = 'UPLAY_AUTHENTICATE_SUCCESS'
const UPLAY_AUTHENTICATE_FAILURE = 'UPLAY_AUTHENTICATE_FAILURE'
const UPLAY_CHECK_AUTHENTICATE_SUCCESS = 'UPLAY_CHECK_AUTHENTICATE_SUCCESS'
const UPLAY_CHECK_AUTHENTICATE_FAILURE = 'UPLAY_CHECK_AUTHENTICATE_FAILURE'
const UPLAY_LOGOUT_SUCCESS = 'UPLAY_LOGOUT_SUCCESS'

export default {
  UPLAY_ACTIVATE_GAME_REQUEST,
  UPLAY_ACTIVATE_GAME_SUCCESS,
  UPLAY_ACTIVATE_GAME_FAILURE,
  UPLAY_AUTHENTICATE_SUCCESS,
  UPLAY_AUTHENTICATE_FAILURE,
  UPLAY_CHECK_AUTHENTICATE_SUCCESS,
  UPLAY_CHECK_AUTHENTICATE_FAILURE,
  UPLAY_LOGOUT_SUCCESS,
}
